import {
  GET_USER_WALLET,
  GET_USER_WALLET_SUCCESS,
  GET_USER_WALLET_FAILURE,
  CREATE_FUNDING_INTENT,
  CREATE_FUNDING_INTENT_SUCCESS,
  CREATE_FUNDING_INTENT_FAILURE,
  INITIALIZE_FUNDING_PAYMENT,
  INITIALIZE_FUNDING_PAYMENT_SUCCESS,
  INITIALIZE_FUNDING_PAYMENT_FAILURE,
  VERIFY_FUNDING_PAYMENT,
  VERIFY_FUNDING_PAYMENT_SUCCESS,
  VERIFY_FUNDING_PAYMENT_FAILURE,
  GET_WALLET_HISTORY,
  GET_WALLET_HISTORY_SUCCESS,
  GET_WALLET_HISTORY_FAILURE,
  GET_ADMIN_WALLET_HISTORY,
  GET_ADMIN_WALLET_HISTORY_SUCCESS,
  GET_ADMIN_WALLET_HISTORY_FAILURE,
  PROCESS_WALLET_REFUND,
  PROCESS_WALLET_REFUND_SUCCESS,
  PROCESS_WALLET_REFUND_FAILURE,
  PROCESS_WALLET_REWARD,
  PROCESS_WALLET_REWARD_SUCCESS,
  PROCESS_WALLET_REWARD_FAILURE,
  GET_CUSTOMER_WALLETS,
  GET_CUSTOMER_WALLETS_SUCCESS,
  GET_CUSTOMER_WALLETS_FAILURE,
} from "../ActionTypes";

const INIT_STATE = {
  walletData: {},
  isLoadingWallet: false,
  walletError: "",
  fundingIntent: {},
  isCreatingIntent: false,

  paymentInit: {},
  isInitializingPayment: false,

  verificationData: {},
  isVerifyingPayment: false,

  walletHistory: [],
  walletStatistics: {},
  walletPagination: {
    current: 1,
    total: 0,
    pageSize: 20,
  },
  isLoadingWalletHistory: false,

  adminWalletHistory: [],
  adminWalletPagination: { current: 1, total: 0, pageSize: 20 },
  isLoadingAdminWalletHistory: false,

  isProcessingRefund: false,
  isProcessingReward: false,
  refundStatus: null,
  rewardStatus: null,

  customerWallets: [],
  customerWalletsPagination: { current: 1, total: 0, pageSize: 20 },
  isLoadingCustomerWallets: false,
};

function WalletReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case GET_USER_WALLET:
      return {
        ...state,
        isLoadingWallet: true,
        walletError: "",
      };
    case GET_USER_WALLET_SUCCESS:
      return {
        ...state,
        walletData: action.payload,
        isLoadingWallet: false,
        walletError: "",
      };
    case GET_USER_WALLET_FAILURE:
      return {
        ...state,
        isLoadingWallet: false,
        walletError: action.payload,
      };
    case CREATE_FUNDING_INTENT:
      return { ...state, isCreatingIntent: true };
    case CREATE_FUNDING_INTENT_SUCCESS:
      return {
        ...state,
        fundingIntent: action.payload,
        isCreatingIntent: false,
      };
    case CREATE_FUNDING_INTENT_FAILURE:
      return { ...state, isCreatingIntent: false };

    // Initialize
    case INITIALIZE_FUNDING_PAYMENT:
      return { ...state, isInitializingPayment: true };
    case INITIALIZE_FUNDING_PAYMENT_SUCCESS:
      return {
        ...state,
        paymentInit: action.payload,
        isInitializingPayment: false,
      };
    case INITIALIZE_FUNDING_PAYMENT_FAILURE:
      return { ...state, isInitializingPayment: false };

    // Verify
    case VERIFY_FUNDING_PAYMENT:
      return { ...state, isVerifyingPayment: true };
    case VERIFY_FUNDING_PAYMENT_SUCCESS:
      return {
        ...state,
        verificationData: action.payload,
        isVerifyingPayment: false,
      };
    case VERIFY_FUNDING_PAYMENT_FAILURE:
      return { ...state, isVerifyingPayment: false };
    case GET_WALLET_HISTORY:
      return { ...state, isLoadingWalletHistory: true };
    case GET_WALLET_HISTORY_SUCCESS:
      // Safely extract the array
      let historyArray = [];
      let pagMeta = {};

      if (Array.isArray(action.payload)) {
        historyArray = action.payload;
      } else if (Array.isArray(action.payload?.data)) {
        historyArray = action.payload.data;
      } else if (Array.isArray(action.payload?.data?.data)) {
        historyArray = action.payload.data.data;
        pagMeta = action.payload.data; // Capture pagination data wrapper
      }

      return {
        ...state,
        isLoadingWalletHistory: false,
        walletHistory: historyArray,
        walletStatistics:
          action.payload?.statistics || action.payload?.data?.statistics || {},
        // Save pagination meta
        walletPagination: {
          current: pagMeta.current_page || 1,
          total: pagMeta.total || historyArray.length,
          pageSize: pagMeta.per_page || 20,
        },
      };
    case GET_WALLET_HISTORY_FAILURE:
      return { ...state, isLoadingWalletHistory: false };

    case GET_ADMIN_WALLET_HISTORY:
      return { ...state, isLoadingAdminWalletHistory: true };
    case GET_ADMIN_WALLET_HISTORY_SUCCESS:
      const adminHistData = action.payload?.data?.data || [];
      const adminPagMeta = action.payload?.data || {};
      return {
        ...state,
        isLoadingAdminWalletHistory: false,
        adminWalletHistory: adminHistData,
        adminWalletPagination: {
          current: adminPagMeta.current_page || 1,
          total: adminPagMeta.total || adminHistData.length,
          pageSize: adminPagMeta.per_page || 20,
        },
      };
    case GET_ADMIN_WALLET_HISTORY_FAILURE:
      return { ...state, isLoadingAdminWalletHistory: false };

    case GET_CUSTOMER_WALLETS:
      return { ...state, isLoadingCustomerWallets: true };
    case GET_CUSTOMER_WALLETS_SUCCESS:
      const custData = action.payload?.data?.data || [];
      const custPagMeta = action.payload?.data || {};
      return {
        ...state,
        isLoadingCustomerWallets: false,
        customerWallets: custData,
        customerWalletsPagination: {
          current: custPagMeta.current_page || 1,
          total: custPagMeta.total || custData.length,
          pageSize: custPagMeta.per_page || 20,
        },
      };
    case GET_CUSTOMER_WALLETS_FAILURE:
      return { ...state, isLoadingCustomerWallets: false };

    case PROCESS_WALLET_REFUND:
      return { ...state, isProcessingRefund: true, refundStatus: null };
    case PROCESS_WALLET_REFUND_SUCCESS:
      return { ...state, isProcessingRefund: false, refundStatus: true };
    case PROCESS_WALLET_REFUND_FAILURE:
      return { ...state, isProcessingRefund: false, refundStatus: false };

    case PROCESS_WALLET_REWARD:
      return { ...state, isProcessingReward: true, rewardStatus: null };
    case PROCESS_WALLET_REWARD_SUCCESS:
      return { ...state, isProcessingReward: false, rewardStatus: true };
    case PROCESS_WALLET_REWARD_FAILURE:
      return { ...state, isProcessingReward: false, rewardStatus: false };
    default:
      return state;
  }
}

export default WalletReducer;
export const getWalletReducer = (state) => state.walletReducer;
